import { createFileRoute } from "@tanstack/react-router";
import { DiscordBioPage } from "../pages/DiscordBioPage";
import { site } from "../config/site";

const title = "Discord Bio Maker | Discord Bio Template Copy and Paste";
const description =
  "Pick a Discord bio layout with symbols or kaomoji. Add your text, choose a font and extra symbols, then preview and copy your aesthetic Discord bio.";
const canonical = `${site.origin}/discord-bio/`;
const image = `${site.origin}/discord-bio-social.png`;
const imageAlt =
  "Discord Bio Maker — choose a template, add your text, and copy your bio.";

export const Route = createFileRoute("/discord-bio")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonical },
      { property: "og:locale", content: "en_US" },
      { property: "og:image", content: image },
      { property: "og:image:alt", content: imageAlt },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: image },
      { name: "twitter:image:alt", content: imageAlt },
    ],
    links: [{ rel: "canonical", href: canonical }],
  }),
  component: DiscordBioPage,
});
